import "./deepagent-avatar.js";

/**
 * The agent travels as one figure: a stand-in flies from where it was to where it
 * lands, laid out against `frame`, and the real figure shows once it arrives.
 */
export function flyFigure(options: {
  from: DOMRect;
  target: HTMLElement;
  avatarUrl: string | null;
  layer: ShadowRoot | HTMLElement;
  frame: HTMLElement;
}): void {
  const { from, target, avatarUrl, layer, frame } = options;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const to = target.getBoundingClientRect();
  if (!from.width || !to.width) return;
  const ghost = document.createElement("deepagent-avatar");
  if (typeof ghost.animate !== "function") return;
  ghost.url = avatarUrl;
  ghost.cells = (target as HTMLElement & { cells?: number }).cells ?? 3;
  const box = frame.getBoundingClientRect();
  ghost.style.cssText = `position:absolute;left:${to.left - box.left}px;top:${to.top - box.top}px;z-index:1;pointer-events:none;--da-avatar-size:${to.width}px`;
  const dx = from.left + from.width / 2 - (to.left + to.width / 2);
  const dy = from.top + from.height / 2 - (to.top + to.height / 2);
  target.style.visibility = "hidden";
  layer.append(ghost);
  const flight = ghost.animate(
    [
      { transform: `translate(${dx}px, ${dy}px) scale(${from.width / to.width})` },
      { transform: "none" },
    ],
    { duration: 440, easing: "cubic-bezier(0.16, 1, 0.3, 1)" },
  );
  const land = () => {
    ghost.remove();
    target.style.visibility = "";
  };
  flight.onfinish = land;
  flight.oncancel = land;
}
